import { CheckPromoCodeInput } from '../../lib/types/models/promo-code/check-promocode-input'
import { PromoCode } from '../../lib/types/models/promo-code/promo-code'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const checkPromoCode = async (input: CheckPromoCodeInput) => {
  return restApiClient
    .url(constructApiUrl(API.promoCodes.checkPromoCode.url, null))
    .post<PromoCode, CheckPromoCodeInput>(input)
}
